import { ContentfulClientApi, createClient } from 'contentful'

const clients: Record<
  string,
  ContentfulClientApi<'WITHOUT_UNRESOLVABLE_LINKS'>
> = {}
export function getContentfulClient({
  space,
  accessToken,
  environment = 'master',
}: {
  space: string
  accessToken: string
  environment?: string
}): ContentfulClientApi<'WITHOUT_UNRESOLVABLE_LINKS'> {
  if (clients[space]) {
    return clients[space]
  }
  const client = createClient({
    space,
    accessToken,
    environment,
  })
  clients[space] = client.withoutUnresolvableLinks
  return clients[space]
}
